import React from "react";

export const DownloadIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 6.79289V1C5.5 0.723857 5.72386 0.5 6 0.5C6.27614 0.5 6.5 0.723857 6.5 1V6.79289L8.14645 5.14645C8.34171 4.95118 8.65829 4.95118 8.85355 5.14645C9.04882 5.34171 9.04882 5.65829 8.85355 5.85355L6.35355 8.35355C6.15829 8.54882 5.84171 8.54882 5.64645 8.35355L3.14645 5.85355C2.95118 5.65829 2.95118 5.34171 3.14645 5.14645C3.34171 4.95118 3.65829 4.95118 3.85355 5.14645L5.5 6.79289Z" />
    <path d="M1 7.5C1.27614 7.5 1.5 7.72386 1.5 8V10C1.5 10.2761 1.72386 10.5 2 10.5H10C10.2761 10.5 10.5 10.2761 10.5 10V8C10.5 7.72386 10.7239 7.5 11 7.5C11.2761 7.5 11.5 7.72386 11.5 8V10C11.5 10.8284 10.8284 11.5 10 11.5H2C1.17157 11.5 0.5 10.8284 0.5 10V8C0.5 7.72386 0.723858 7.5 1 7.5Z" />
  </svg>
);
